import { mediaCoverage } from "../../../components/data";
import "./mediaCoverage.scss";

const MediaCoverage = () => {
    const doubled = [...mediaCoverage, ...mediaCoverage];

    return (
        <section className="media-coverage" aria-labelledby="media-coverage-heading">
            <div className="media-coverage__header">
                <p className="media-coverage__label">AS SEEN IN</p>
                <h2 className="media-coverage__title" id="media-coverage-heading">Media Coverage</h2>
            </div>

            <div className="media-coverage__track-wrapper">
                <div className="media-coverage__track">
                    {doubled.map((media, index) => (
                        <div key={index} className="media-coverage__logo">
                            <img
                                src={media.image}
                                alt={`Pulpit Cabs featured in media publication ${(index % mediaCoverage.length) + 1}`}
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default MediaCoverage;
